import { LiveEditorStepKey } from "../LiveEditorStep.enum";

import { StepToElementIdMap } from "@/components/LiveEditorElements/StepTypes";

export const TICKETING_SELECTION_V2_INNER_ID = "ticketing-selection-v2-inner";
export const TICKETING_SELECTION_V2_RATE_ID_PREFIX = "ticketing-selection-v2-rate-";

/**
 * Static element IDs for form steps.
 * Use this when you need a simple string ID (e.g., for HTML id attributes).
 * For dynamic IDs (tickets, questions), use FORM_STEP_TO_ELEMENT_ID directly.
 */
export const FORM_ELEMENT_IDS = {
  title: "form-title",
  date: "ticketing-date-summary",
  location: "ticketing-address-summary",
  description: "form-v2-description",
  banner: "ticketing-banner",
  logo: "logo",
  "add-donation": "extra-donation-amount-input",
  "thank-you-email": "live-preview-email",
  "thank-you-email-not-winner": "live-preview-email",
  "discount-codes": "discount-code-field",
  "business-model": "tip-section-input",
  "suggested-donation-amounts": "amounts",
  "fundraising-goal": "thermometer-component",
  prizes: "ticketing-prizes",
} as const;

/**
 * Mapping from form step keys to element IDs for arrow positioning in the preview.
 * Some values are functions that require context (rateIndexInFocus, questionIndexInFocus).
 */
export const FORM_STEP_TO_ELEMENT_ID: StepToElementIdMap<LiveEditorStepKey> = {
  ...FORM_ELEMENT_IDS,
  "campaign-life-cycle": undefined,
  "add-ons": "extra-donation-amount-input",
  color: undefined,
  tickets: ({ rateIdInFocus }) =>
    rateIdInFocus ? `${TICKETING_SELECTION_V2_RATE_ID_PREFIX}${rateIdInFocus}` : undefined,
  questions: ({ questionIndexInFocus, scope, rateIndexInFocus, fundDesignationInFocus }) => {
    if (fundDesignationInFocus) {
      return "fund-designation";
    }
    if (scope === "buyer") {
      return `buyer-question-${questionIndexInFocus ?? 0}`;
    }
    return `rate-${rateIndexInFocus ?? 0}-group-0-participant-0-question-${questionIndexInFocus ?? 0}`;
  },
  prizes: FORM_ELEMENT_IDS.prizes,
  "e-ticket": undefined,
  "quickbooks-mapping": undefined,
  "advanced-settings": undefined,
  "automated-communications": undefined,
  review: undefined,
  "tax-receipts": undefined,
  "p2p-settings": undefined,
  "order-fulfillment": "fulfillment-section",
};
